<template>
	<div class="outline lists">
		<router-link :to="{ name: 'ProjectDetail', params: { title: params(work.title) } }"  class="list" v-for="(work, idx) of works" :key="idx">
			<div><img :src=work.bg_image class="img" /></div>
			<div class="title">{{ work.title }}</div>
		</router-link>
    
  </div>


  <div class="copyright">
      <div class="social">
          <a href="https://www.linkedin.com/in/hanbyeoll/" target="_blank"><img src="/portfolio/images/icon-linkdin.png" /></a>
          <a href="https://dribbble.com/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-dribbble.png" /></a>
          <a href="https://www.behance.net/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-behance.png" /></a>
          <a href="https://github.com/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-github.png" /></a>
      </div>
      <div>
          © Copyright hanbyeoll.github.io. All Rights Reserved.
      </div>
  </div>
</template>

<script>
export default {
  name: 'Page.Project',
  data() {
    return {
      works : [],
    }
  },
  mounted() {
    this.works = this.$root.works

    setTimeout(() => {
      const lists = document.querySelectorAll('.list')
      for(var list of lists) list.classList.add('on')
    }, 500)
    
  },
  methods: {
    params(v) {
      return v.toLowerCase().replace(/\s/g,'-')
    }
  },
}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/project.scss';
</style>